import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { LOCALES, type Locale } from '@repo/shared';
import ar from './locales/ar.json';
import en from './locales/en.json';
import fr from './locales/fr.json';

const STORAGE_KEY = 'sol-lang';

export function storedLocale(): Locale | null {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return (LOCALES as readonly string[]).includes(v ?? '') ? (v as Locale) : null;
  } catch {
    return null;
  }
}

export const directionOf = (locale: Locale) => (locale === 'ar' ? 'rtl' : 'ltr');

void i18n.use(initReactI18next).init({
  resources: { fr: { translation: fr }, ar: { translation: ar }, en: { translation: en } },
  lng: storedLocale() ?? 'fr',
  fallbackLng: 'fr',
  interpolation: { escapeValue: false },
  returnNull: false,
});

/** Switches language, persists it and updates <html lang dir> (RTL for Arabic). */
export async function setLocale(locale: Locale): Promise<void> {
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    // storage unavailable: language still applies for this session
  }
  document.documentElement.lang = locale;
  document.documentElement.dir = directionOf(locale);
  await i18n.changeLanguage(locale);
}

export { i18n };
